export const DEFAULT_PROFILE_PHOTO =
  'https://www.paypalobjects.com/digitalassets/c/consumer/paypalme/networkidentity/profile_man.svg'

export const COVER_PHOTO_URLS = {
  GREEN: {
    RASTER: 'https://www.paypalobjects.com/profiles/cover/green.jpg',
    VECTOR: 'https://www.paypalobjects.com/profiles/cover/green.svg',
  },
  BLUE: {
    RASTER: 'https://www.paypalobjects.com/profiles/cover/blue.jpg',
    VECTOR: 'https://www.paypalobjects.com/profiles/cover/blue.svg',
  },
  PURPLE: {
    RASTER: 'https://www.paypalobjects.com/profiles/cover/purple.jpg',
    VECTOR: 'https://www.paypalobjects.com/profiles/cover/purple.svg',
  },
  RED: {
    RASTER: 'https://www.paypalobjects.com/profiles/cover/red.jpg',
    VECTOR: 'https://www.paypalobjects.com/profiles/cover/red.svg',
  },
  YELLOW: {
    RASTER: 'https://www.paypalobjects.com/profiles/cover/yellow.jpg',
    VECTOR: 'https://www.paypalobjects.com/profiles/cover/yellow.svg',
  },
}

export const INSTRUMENTATION_MAP = {
  profile: {
    OLD: {
      PAGE_GROUP: 'main:ppme:profile:preview',
      PAGE_NAME: 'main:ppme:profile:preview',
    },
    NEW: {
      back: 'public_identity_my_profile_back_pressed',
      close: 'public_identity_my_profile_close_pressed',
    },
  },
  about: {
    OLD: {
      PAGE_GROUP: 'main:ppme:about',
      PAGE_NAME: 'main:ppme:about',
    },
    NEW: {
      back: 'public_identity_edit_about_back_pressed',
      close: 'public_identity_edit_about_close_pressed',
    },
  },
  confirm: {
    OLD: {
      PAGE_GROUP: 'main:ppme:hide:confirm',
      PAGE_NAME: 'main:ppme:hide:confirm',
    },
    NEW: {
      back: 'public_identity_hide_profile_confirmation_back_pressed',
      close: 'public_identity_hide_profile_confirmation_close_pressed',
    },
  },
  location: {
    OLD: {
      PAGE_GROUP: 'main:ppme:location',
      PAGE_NAME: 'main:ppme:location',
    },
    NEW: {
      back: 'public_identity_edit_location_back_pressed',
      close: 'public_identity_edit_location_close_pressed',
    },
  },
  recipient: {
    OLD: {
      PAGE_GROUP: 'main:ppme:recipientprofile',
      PAGE_NAME: 'main:ppme:recipientprofile:::',
    },
  },
  settings: {
    OLD: {
      PAGE_GROUP: 'main:ppme:settings',
      PAGE_NAME: 'main:ppme:settings:::',
    },
    NEW: {
      close: 'public_identity_edit_profile_close_pressed',
    },
  },
  username: {
    OLD: {
      PAGE_GROUP: 'main:ppme:username',
      PAGE_NAME: 'main:ppme:username:::change',
    },
    NEW: {
      back: 'public_identity_edit_username_back_pressed',
      close: 'public_identity_edit_username_close_pressed',
    },
  },
  'cover/select': {
    OLD: {
      PAGE_GROUP: 'main:ppme:background:edit',
      PAGE_NAME: 'main:ppme:background:edit',
    },
    NEW: {
      back: 'public_identity_background_edit_back_pressed',
      close: 'public_identity_background_edit_close_pressed',
    },
  },
  'cover/pan': {
    OLD: {
      PAGE_GROUP: 'main:ppme:background:adjust',
      PAGE_NAME: 'main:ppme:background:adjust',
    },
    NEW: {
      back: 'public_identity_background_adjust_back_pressed',
      close: 'public_identity_background_adjust_close_pressed',
    },
  },
  picture: {
    OLD: {
      PAGE_GROUP: 'main:ppme:profile_pic:edit',
      PAGE_NAME: 'main:ppme:profile_pic:edit',
    },
    NEW: {
      back: 'public_identity_profile_picture_edit_back_pressed',
      close: 'public_identity_profile_picture_edit_close_pressed',
    },
  },
}

export const ILLUSTRATIONS = {
  WARNING:
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/warning.svg',
}

export const SELLER_COVER_PHOTO_URLS = {
  GREEN: {
    RASTER:
      'https://www.paypalobjects.com/p2p_seller_profiles/background_covers/green.jpg',
    VECTOR:
      'https://www.paypalobjects.com/p2p_seller_profiles/background_covers/green.svg',
  },
  BLUE: {
    RASTER:
      'https://www.paypalobjects.com/p2p_seller_profiles/background_covers/blue.jpg',
    VECTOR:
      'https://www.paypalobjects.com/p2p_seller_profiles/background_covers/blue.svg',
  },
  PURPLE: {
    RASTER:
      'https://www.paypalobjects.com/p2p_seller_profiles/background_covers/purple.jpg',
    VECTOR:
      'https://www.paypalobjects.com/p2p_seller_profiles/background_covers/purple.svg',
  },
  PINK: {
    RASTER:
      'https://www.paypalobjects.com/p2p_seller_profiles/background_covers/pink.jpg',
    VECTOR:
      'https://www.paypalobjects.com/p2p_seller_profiles/background_covers/pink.svg',
  },
}

export const SELLER_SETTING_TYPES = {
  SHOW: 'show',
  HIDE: 'hide',
}
